// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
import { useState } from "react"
import { Navigate, useNavigate } from "react-router-dom"
import { login, isAuthed } from "@/lib/auth"
import { syncFromPocketBase } from "@/lib/data"

export default function LoginPage() {
  const navigate = useNavigate()
  const [kennung, setKennung] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const [busy, setBusy] = useState(false)

  if (isAuthed()) return <Navigate to="/start" replace />

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError("")
    setBusy(true)
    try {
      await login(kennung.trim(), password)
      void syncFromPocketBase()
      navigate("/start", { replace: true })
    } catch (err: unknown) {
      // Lockout-Meldung des Servers durchreichen, sonst neutrale Meldung (keine User-Enumeration)
      const msg = err instanceof Error ? err.message : ""
      setError(msg.includes("gesperrt") ? msg : "Benutzername oder Passwort falsch.")
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <header className="app-header">
        <p className="eyebrow">fitHub</p>
        <h1>Anmelden</h1>
      </header>
      <div className="wrap" style={{ maxWidth: 420 }}>
        <form className="card" style={{ marginTop: 24 }} onSubmit={onSubmit}>
          <label htmlFor="kennung">Benutzername oder E-Mail</label>
          <input id="kennung" type="text" autoComplete="username" autoCapitalize="none" spellCheck={false}
            required value={kennung} onChange={(e) => setKennung(e.target.value)} />
          <label htmlFor="password">Passwort</label>
          <input id="password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          {error && <p className="form-error" role="alert">{error}</p>}
          <button className="save" type="submit" disabled={busy}>{busy ? "Anmelden…" : "Anmelden"}</button>
          <p className="hint" style={{ marginTop: 14 }}>
            Kein Konto? Zugänge vergibt Thor persönlich – wie ein Hausschlüssel.
          </p>
        </form>
        <footer>fitHub · Deine Daten bleiben auf unserem eigenen Server.</footer>
      </div>
    </>
  )
}
